function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2016(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 15.1,
    height: 7.11,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 0.7110000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.55,
    y: 3.555
  }, "\n        Taliaferro\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 7.11,
    width: 15.1,
    height: 8.28,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.1828571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.55,
    y: 11.25
  }, "\n        Quitman\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 15.39,
    width: 15.1,
    height: 8.85,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.2642857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.55,
    y: 19.815
  }, "\n        Webster\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 24.24,
    width: 15.1,
    height: 9.32,
    style: {
      fill: "#660000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.5533333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.55,
    y: 28.9
  }, "\n        Echols\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 33.56,
    width: 15.1,
    height: 10.08,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.52
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.55,
    y: 38.6
  }, "\n        Clay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 43.64,
    width: 15.1,
    height: 11.02,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 0.8476923076923076
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.55,
    y: 49.15
  }, "\n        Chattahoochee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 54.66,
    width: 15.1,
    height: 11.02,
    style: {
      fill: "#660000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.3775
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.55,
    y: 60.169999999999995
  }, "\n        Glascock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 65.68,
    width: 15.1,
    height: 11.42,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.284
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.55,
    y: 71.39
  }, "\n        Baker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 77.09,
    width: 15.1,
    height: 15.13,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.5166666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.55,
    y: 84.655
  }, "\n        Schley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 92.23,
    width: 15.1,
    height: 16.05,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.157142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.55,
    y: 100.25500000000001
  }, "\n        Calhoun\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 108.28,
    width: 15.1,
    height: 16.29,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.157142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.55,
    y: 116.425
  }, "\n        Stewart\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 124.57,
    width: 15.1,
    height: 16.66,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.157142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.55,
    y: 132.9
  }, "\n        Wheeler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 141.24,
    width: 15.1,
    height: 18.5,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.5166666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.55,
    y: 150.49
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 159.74,
    width: 15.1,
    height: 19.4,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.5166666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.55,
    y: 169.44
  }, "\n        Clinch\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 179.14,
    width: 15.1,
    height: 20.17,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.5166666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.55,
    y: 189.225
  }, "\n        Miller\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 199.31,
    width: 15.1,
    height: 20.69,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.8875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.55,
    y: 209.655
  }, "\n        Atkinson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 220,
    width: 15.1,
    height: 21.43,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.8875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.55,
    y: 230.715
  }, "\n        Treutlen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 241.43,
    width: 15.1,
    height: 22.7,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.5166666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.55,
    y: 252.78
  }, "\n        Lanier\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 264.13,
    width: 15.1,
    height: 22.97,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.8875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.55,
    y: 275.615
  }, "\n        Randolph\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 287.09,
    width: 15.1,
    height: 23.57,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.5166666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.55,
    y: 298.875
  }, "\n        Wilcox\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 310.66,
    width: 15.1,
    height: 24.2,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.157142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.55,
    y: 322.76000000000005
  }, "\n        Jenkins\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 334.86,
    width: 15.1,
    height: 25.24,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.5166666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.55,
    y: 347.48
  }, "\n        Marion\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 360.1,
    width: 15.1,
    height: 25.72,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.5166666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.55,
    y: 372.96000000000004
  }, "\n        Talbot\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 385.82,
    width: 15.1,
    height: 26.91,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.5166666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.55,
    y: 399.275
  }, "\n        Turner\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 412.72,
    width: 15.1,
    height: 27,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.5166666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.55,
    y: 426.22
  }, "\n        Taylor\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 439.72,
    width: 15.1,
    height: 28.24,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.51
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.55,
    y: 453.84000000000003
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 467.96,
    width: 15.1,
    height: 28.38,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.157142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.55,
    y: 482.15
  }, "\n        Hancock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 496.34,
    width: 15.1,
    height: 28.4,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.8875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.55,
    y: 510.53999999999996
  }, "\n        Seminole\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 524.74,
    width: 15.1,
    height: 28.53,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.157142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.55,
    y: 539.005
  }, "\n        Pulaski\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 553.27,
    width: 15.1,
    height: 28.56,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.02
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.55,
    y: 567.55
  }, "\n        Evans\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 581.83,
    width: 15.1,
    height: 29.06,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.02
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.55,
    y: 596.36
  }, "\n        Irwin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 610.89,
    width: 15.1,
    height: 29.19,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.157142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.55,
    y: 625.485
  }, "\n        Johnson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 640.08,
    width: 15.1,
    height: 29.83,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.157142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.55,
    y: 654.995
  }, "\n        Candler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 669.91,
    width: 15.1,
    height: 30.09,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.157142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 7.55,
    y: 684.9549999999999
  }, "\n        Telfair\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 0,
    width: 18.76,
    height: 24.63,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.7520000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 24.48,
    y: 12.315
  }, "\n        Dooly\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33.86,
    y: 0,
    width: 19.49,
    height: 24.63,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.43625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.605,
    y: 12.315
  }, "\n        Charlton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.35,
    y: 0,
    width: 19.54,
    height: 24.63,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.908
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 63.120000000000005,
    y: 12.315
  }, "\n        Bacon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.89,
    y: 0,
    width: 19.72,
    height: 24.63,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.2866666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 82.75,
    y: 12.315
  }, "\n        Twiggs\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 92.61,
    y: 0,
    width: 19.94,
    height: 24.63,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.8485714285714288
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 102.58,
    y: 12.315
  }, "\n        Lincoln\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 112.55,
    y: 0,
    width: 20.01,
    height: 24.63,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.0025
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 122.55499999999999,
    y: 12.315
  }, "\n        Long\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 132.56,
    y: 0,
    width: 20.33,
    height: 24.63,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.904285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 142.725,
    y: 12.315
  }, "\n        Terrell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 152.89,
    y: 0,
    width: 20.45,
    height: 24.63,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.09
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 163.11499999999998,
    y: 12.315
  }, "\n        Heard\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 173.34,
    y: 0,
    width: 20.8,
    height: 24.63,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.3111111111111113
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 183.74,
    y: 12.315
  }, "\n        Wilkinson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 194.13,
    y: 0,
    width: 20.84,
    height: 24.63,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.168
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 204.54999999999998,
    y: 12.315
  }, "\n        Macon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 214.97,
    y: 0,
    width: 21.76,
    height: 24.63,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.626666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 225.85,
    y: 12.315
  }, "\n        Wilkes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 236.74,
    y: 0,
    width: 23.26,
    height: 24.63,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.652
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 248.37,
    y: 12.315
  }, "\n        Early\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 0,
    width: 24.03,
    height: 24.63,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.00375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 272.015,
    y: 12.315
  }, "\n        Bleckley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 284.03,
    y: 0,
    width: 24.75,
    height: 24.63,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.463
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 296.405,
    y: 12.315
  }, "\n        Jeff_Davis\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 308.78,
    y: 0,
    width: 25.09,
    height: 24.63,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.07875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 321.325,
    y: 12.315
  }, "\n        Crawford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 333.87,
    y: 0,
    width: 27.71,
    height: 24.63,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.5185714285714282
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 347.725,
    y: 12.315
  }, "\n        Screven\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 361.58,
    y: 0,
    width: 28.7,
    height: 24.63,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.07875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 375.93,
    y: 12.315
  }, "\n        McIntosh\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 390.28,
    y: 0,
    width: 28.83,
    height: 24.63,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.07875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 404.695,
    y: 12.315
  }, "\n        Ben_Hill\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 419.11,
    y: 0,
    width: 29.28,
    height: 24.63,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.1049999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 433.75,
    y: 12.315
  }, "\n        Jasper\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 448.39,
    y: 0,
    width: 29.37,
    height: 24.63,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.1575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 463.075,
    y: 12.315
  }, "\n        Cook\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 477.76,
    y: 0,
    width: 30.34,
    height: 24.63,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.1575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 492.93,
    y: 12.315
  }, "\n        Dade\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 508.1,
    y: 0,
    width: 30.59,
    height: 24.63,
    style: {
      fill: "#660000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.07875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 523.395,
    y: 12.315
  }, "\n        Brantley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 538.69,
    y: 0,
    width: 30.71,
    height: 24.63,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.1049999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 554.0450000000001,
    y: 12.315
  }, "\n        Brooks\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 569.4,
    y: 0,
    width: 32.01,
    height: 24.63,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.5185714285714282
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 585.405,
    y: 12.315
  }, "\n        Berrien\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 601.41,
    y: 0,
    width: 32.35,
    height: 24.63,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.463
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 617.5849999999999,
    y: 12.315
  }, "\n        Oglethorpe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 633.76,
    y: 0,
    width: 32.76,
    height: 24.63,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.926
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 650.14,
    y: 12.315
  }, "\n        Towns\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 666.52,
    y: 0,
    width: 33.48,
    height: 24.63,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.07875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 683.26,
    y: 12.315
  }, "\n        Tattnall\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 24.63,
    width: 31.74,
    height: 26.22,
    style: {
      fill: "#660000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.244
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 30.97,
    y: 37.739999999999995
  }, "\n        Banks\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 50.85,
    width: 31.74,
    height: 26.23,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.9144444444444444
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 30.97,
    y: 63.965
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 77.08,
    width: 31.74,
    height: 26.4,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.279999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 30.97,
    y: 90.28
  }, "\n        Dodge\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 103.48,
    width: 31.74,
    height: 26.43,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.775714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 30.97,
    y: 116.69500000000001
  }, "\n        Appling\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 129.91,
    width: 31.74,
    height: 27.53,
    style: {
      fill: "#660000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.588333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 30.97,
    y: 143.675
  }, "\n        Pierce\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 157.44,
    width: 31.74,
    height: 28.34,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 30.97,
    y: 171.60999999999999
  }, "\n        Crisp\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 185.78,
    width: 31.74,
    height: 28.62,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.724
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 30.97,
    y: 200.09
  }, "\n        Lamar\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 214.39,
    width: 31.74,
    height: 29.59,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.227142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 30.97,
    y: 229.18499999999997
  }, "\n        Emanuel\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 243.99,
    width: 31.74,
    height: 29.67,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.70875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 30.97,
    y: 258.825
  }, "\n        Mitchell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 273.66,
    width: 31.74,
    height: 29.99,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.997999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 30.97,
    y: 288.65500000000003
  }, "\n        Rabun\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 303.65,
    width: 31.74,
    height: 30.07,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.011666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 30.97,
    y: 318.685
  }, "\n        Elbert\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 333.71,
    width: 31.74,
    height: 31.13,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.4588888888888887
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 30.97,
    y: 349.275
  }, "\n        Chattooga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 364.84,
    width: 31.74,
    height: 31.24,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.247999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 30.97,
    y: 380.46
  }, "\n        Worth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 396.08,
    width: 31.74,
    height: 31.87,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.174
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 30.97,
    y: 412.015
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 427.95,
    width: 31.74,
    height: 31.97,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.9675
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 30.97,
    y: 443.935
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 459.91,
    width: 31.74,
    height: 32.75,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.935
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 30.97,
    y: 476.285
  }, "\n        Pike\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 492.66,
    width: 31.74,
    height: 33.35,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.29
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 30.97,
    y: 509.33500000000004
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 526.01,
    width: 31.74,
    height: 34.37,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.29
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 30.97,
    y: 543.1949999999999
  }, "\n        Toombs\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 560.38,
    width: 31.74,
    height: 34.67,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.174
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 30.97,
    y: 577.715
  }, "\n        Meriwether\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 595.05,
    width: 31.74,
    height: 34.71,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.348
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 30.97,
    y: 612.405
  }, "\n        Grady\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 629.76,
    width: 31.74,
    height: 34.96,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.9675
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 30.97,
    y: 647.24
  }, "\n        McDuffie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 664.72,
    width: 31.74,
    height: 35.28,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.348
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 30.97,
    y: 682.36
  }, "\n        Burke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.84,
    y: 24.63,
    width: 31.36,
    height: 36.04,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.226666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 62.52,
    y: 42.65
  }, "\n        Morgan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 78.2,
    y: 24.63,
    width: 31.47,
    height: 36.04,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.245
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 93.935,
    y: 42.65
  }, "\n        Putnam\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 109.67,
    y: 24.63,
    width: 31.48,
    height: 36.04,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.296
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 125.41,
    y: 42.65
  }, "\n        Butts\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 141.16,
    y: 24.63,
    width: 32.44,
    height: 36.04,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.055
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 157.38,
    y: 42.65
  }, "\n        Stephens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 87,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 173.6,
    y: 24.63,
    width: 33.49,
    height: 36.04,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.3725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 190.345,
    y: 42.65
  }, "\n        Hart\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 88,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 207.09,
    y: 24.63,
    width: 34.12,
    height: 36.04,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.874285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 224.15,
    y: 42.65
  }, "\n        Decatur\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 89,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 241.21,
    y: 24.63,
    width: 34.5,
    height: 36.04,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.9
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 258.46000000000004,
    y: 42.65
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 90,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 275.71,
    y: 24.63,
    width: 35.63,
    height: 36.04,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.126
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 293.525,
    y: 42.65
  }, "\n        Peach\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 91,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 311.34,
    y: 24.63,
    width: 36.33,
    height: 36.04,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.208
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 329.505,
    y: 42.65
  }, "\n        Upson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 92,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 347.67,
    y: 24.63,
    width: 36.46,
    height: 36.04,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.006666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 365.90000000000003,
    y: 42.65
  }, "\n        Sumter\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 93,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 384.13,
    y: 24.63,
    width: 37.62,
    height: 36.04,
    style: {
      fill: "#660000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.505
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 402.94,
    y: 42.65
  }, "\n        Haralson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 94,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 421.75,
    y: 24.63,
    width: 38.88,
    height: 36.04,
    style: {
      fill: "#660000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.006666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 441.19,
    y: 42.65
  }, "\n        Dawson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 95,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 460.63,
    y: 24.63,
    width: 39.13,
    height: 36.04,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.006666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 480.195,
    y: 42.65
  }, "\n        Fannin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 96,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 499.76,
    y: 24.63,
    width: 39.15,
    height: 36.04,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.208
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 519.335,
    y: 42.65
  }, "\n        White\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 97,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 538.9,
    y: 24.63,
    width: 39.71,
    height: 36.04,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.148571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 558.755,
    y: 42.65
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 98,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 578.62,
    y: 24.63,
    width: 40.01,
    height: 36.04,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.208
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 598.625,
    y: 42.65
  }, "\n        Union\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 99,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 618.63,
    y: 24.63,
    width: 40.4,
    height: 36.04,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.01
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 638.83,
    y: 42.65
  }, "\n        Ware\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 100,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 659.02,
    y: 24.63,
    width: 40.98,
    height: 36.04,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.148571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 679.51,
    y: 42.65
  }, "\n        Lumpkin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 101,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.84,
    y: 60.67,
    width: 40.11,
    height: 37.09,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.1816666666666675
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 66.89500000000001,
    y: 79.215
  }, "\n        Murray\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 102,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.84,
    y: 97.76,
    width: 40.11,
    height: 37.39,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.478
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 66.89500000000001,
    y: 116.45500000000001
  }, "\n        Jones\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 103,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.84,
    y: 135.15,
    width: 40.11,
    height: 37.88,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.3133333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 66.89500000000001,
    y: 154.09
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 104,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.84,
    y: 173.03,
    width: 40.11,
    height: 38.02,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.336666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 66.89500000000001,
    y: 192.04
  }, "\n        Gilmer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 105,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.84,
    y: 211.05,
    width: 40.11,
    height: 40.6,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.01375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 66.89500000000001,
    y: 231.35000000000002
  }, "\n        Colquitt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 106,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.84,
    y: 251.65,
    width: 40.11,
    height: 41.54,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.685
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 66.89500000000001,
    y: 272.42
  }, "\n        Coffee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 107,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.84,
    y: 293.19,
    width: 40.11,
    height: 41.75,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.7299999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 66.89500000000001,
    y: 314.065
  }, "\n        Pickens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 108,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.84,
    y: 334.94,
    width: 40.11,
    height: 42.14,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.37
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 66.89500000000001,
    y: 356.01
  }, "\n        Lee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 109,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.84,
    y: 377.08,
    width: 40.11,
    height: 42.3,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.0275
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 66.89500000000001,
    y: 398.22999999999996
  }, "\n        Polk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 110,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.84,
    y: 419.38,
    width: 40.11,
    height: 42.32,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.0275
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 66.89500000000001,
    y: 440.54
  }, "\n        Tift\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 111,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.84,
    y: 461.7,
    width: 40.11,
    height: 45.03,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.022
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 66.89500000000001,
    y: 484.215
  }, "\n        Bryan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 112,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.84,
    y: 506.73,
    width: 40.11,
    height: 48.02,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.7299999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 66.89500000000001,
    y: 530.74
  }, "\n        Baldwin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 113,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.84,
    y: 554.76,
    width: 40.11,
    height: 48.12,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.7299999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 66.89500000000001,
    y: 578.8199999999999
  }, "\n        Liberty\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 114,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.84,
    y: 602.87,
    width: 40.11,
    height: 48.17,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.456666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 66.89500000000001,
    y: 626.955
  }, "\n        Habersham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 115,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.84,
    y: 651.04,
    width: 40.11,
    height: 48.96,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.685
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 66.89500000000001,
    y: 675.52
  }, "\n        Harris\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 116,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.95,
    y: 60.67,
    width: 41.96,
    height: 53.47,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.993333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 107.93,
    y: 87.405
  }, "\n        Thomas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 117,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 128.91,
    y: 60.67,
    width: 42.25,
    height: 53.47,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.041666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 150.035,
    y: 87.405
  }, "\n        Camden\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 118,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 171.16,
    y: 60.67,
    width: 42.28,
    height: 53.47,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.046666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 192.3,
    y: 87.405
  }, "\n        Gordon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 119,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 213.44,
    y: 60.67,
    width: 43.61,
    height: 53.47,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.2299999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 235.245,
    y: 87.405
  }, "\n        Laurens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 120,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 257.05,
    y: 60.67,
    width: 44.63,
    height: 53.47,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.4383333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 279.365,
    y: 87.405
  }, "\n        Oconee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 121,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 301.69,
    y: 60.67,
    width: 52.41,
    height: 53.47,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.823333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 327.895,
    y: 87.405
  }, "\n        Effingham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 122,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 354.1,
    y: 60.67,
    width: 53.65,
    height: 53.47,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.911666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 380.925,
    y: 87.405
  }, "\n        Walker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 123,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 407.75,
    y: 60.67,
    width: 56.54,
    height: 53.47,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.638571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 436.02,
    y: 87.405
  }, "\n        Bulloch\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 124,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 464.28,
    y: 60.67,
    width: 57.33,
    height: 53.47,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.68375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 492.945,
    y: 87.405
  }, "\n        Spalding\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 125,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 521.61,
    y: 60.67,
    width: 58.28,
    height: 53.47,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.693999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 550.75,
    y: 87.405
  }, "\n        Troup\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 126,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 579.89,
    y: 60.67,
    width: 59.41,
    height: 53.47,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.638571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 609.595,
    y: 87.405
  }, "\n        Catoosa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 127,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 639.29,
    y: 60.67,
    width: 60.71,
    height: 53.47,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.638571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 669.645,
    y: 87.405
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 128,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.95,
    y: 114.14,
    width: 64.74,
    height: 53.32,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.886666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 119.32,
    y: 140.8
  }, "\n        Barrow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 129,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.95,
    y: 167.46,
    width: 64.74,
    height: 56.22,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.246666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 119.32,
    y: 195.57
  }, "\n        Whitfield\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 130,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.95,
    y: 223.68,
    width: 64.74,
    height: 62.91,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.989999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 119.32,
    y: 255.135
  }, "\n        Dougherty\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 131,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.95,
    y: 286.59,
    width: 64.74,
    height: 63.09,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.618
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 119.32,
    y: 318.135
  }, "\n        Glynn\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 132,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.95,
    y: 349.68,
    width: 64.74,
    height: 63.54,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.708
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 119.32,
    y: 381.45
  }, "\n        Floyd\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 133,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.95,
    y: 413.22,
    width: 64.74,
    height: 69.59,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.248571428571427
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 119.32,
    y: 448.01500000000004
  }, "\n        Lowndes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 134,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.95,
    y: 482.81,
    width: 64.74,
    height: 69.64,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.0925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 119.32,
    y: 517.63
  }, "\n        Rockdale\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 135,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.95,
    y: 552.46,
    width: 64.74,
    height: 72.69,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.79
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 119.32,
    y: 588.8050000000001
  }, "\n        Bartow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 136,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.95,
    y: 625.15,
    width: 64.74,
    height: 74.85,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.79
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 119.32,
    y: 662.5749999999999
  }, "\n        Walton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 137,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 151.69,
    y: 114.14,
    width: 64.75,
    height: 81,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.791666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 184.065,
    y: 154.64
  }, "\n        Newton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 138,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 216.44,
    y: 114.14,
    width: 64.8,
    height: 81,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.257142857142856
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 248.84,
    y: 154.64
  }, "\n        Carroll\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 139,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 281.24,
    y: 114.14,
    width: 65.54,
    height: 81,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.923333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 314.01,
    y: 154.64
  }, "\n        Clarke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 140,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 346.79,
    y: 114.14,
    width: 84.87,
    height: 81,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.571428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 389.225,
    y: 154.64
  }, "\n        Douglas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 141,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 431.66,
    y: 114.14,
    width: 88.31,
    height: 81,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.571428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 475.81500000000005,
    y: 154.64
  }, "\n        Houston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 142,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 519.97,
    y: 114.14,
    width: 89.34,
    height: 81,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.571428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 564.64,
    y: 154.64
  }, "\n        Fayette\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 143,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 609.31,
    y: 114.14,
    width: 90.69,
    height: 81,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.5
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 654.655,
    y: 154.64
  }, "\n        Coweta\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 144,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 151.69,
    y: 195.14,
    width: 96.08,
    height: 77.61,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 19.4025
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 199.73,
    y: 233.945
  }, "\n        Bibb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 145,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 151.69,
    y: 272.75,
    width: 96.08,
    height: 80.06,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.0075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 199.73,
    y: 312.78
  }, "\n        Columbia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 146,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 151.69,
    y: 352.81,
    width: 96.08,
    height: 80.55,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.06875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 199.73,
    y: 393.085
  }, "\n        Paulding\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 147,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 151.69,
    y: 433.36,
    width: 96.08,
    height: 85.56,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.695
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 199.73,
    y: 476.14
  }, "\n        Muscogee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 148,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 151.69,
    y: 518.92,
    width: 96.08,
    height: 87.51,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 21.8775
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 199.73,
    y: 562.675
  }, "\n        Hall\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 149,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 151.69,
    y: 606.43,
    width: 96.08,
    height: 93.57,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.69625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 199.73,
    y: 653.2149999999999
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 150,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 247.77,
    y: 195.14,
    width: 104.83,
    height: 105.67,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.975714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 300.185,
    y: 247.975
  }, "\n        Clayton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 151,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 352.6,
    y: 195.14,
    width: 110.37,
    height: 105.67,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.095714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 407.785,
    y: 247.975
  }, "\n        Forsyth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 152,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 462.97,
    y: 195.14,
    width: 111.37,
    height: 105.67,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 21.134
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 518.655,
    y: 247.975
  }, "\n        Henry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 153,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 574.34,
    y: 195.14,
    width: 125.66,
    height: 105.67,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.20875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 637.1700000000001,
    y: 247.975
  }, "\n        Cherokee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 154,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 247.77,
    y: 300.81,
    width: 127.17,
    height: 104.96,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.994285714285713
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 311.355,
    y: 353.29
  }, "\n        Chatham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 155,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 247.77,
    y: 405.77,
    width: 127.17,
    height: 294.23,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 21.195
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 311.355,
    y: 552.885
  }, "\n        DeKalb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 156,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 374.94,
    y: 300.81,
    width: 162.07,
    height: 240.58,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 20.25875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 455.975,
    y: 421.1
  }, "\n        Gwinnett\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 157,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 537.01,
    y: 300.81,
    width: 162.99,
    height: 240.58,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 40.7475
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 618.505,
    y: 421.1
  }, "\n        Cobb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 158,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 374.94,
    y: 541.39,
    width: 325.06,
    height: 158.61,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 26.435000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 537.47,
    y: 620.6949999999999
  }, "\n        Fulton\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2016);
export default __webpack_public_path__ + "static/media/2016.a65b8967e1a10b4df0aaa469414e01fb.svg";
export { ForwardRef as ReactComponent };